import { render, staticRenderFns } from "./FpuiPackageEditorTranslation.vue?vue&type=template&id=676b4ccf&lang=pug&"
import script from "./FpuiPackageEditorTranslation.vue?vue&type=script&lang=js&"
export * from "./FpuiPackageEditorTranslation.vue?vue&type=script&lang=js&"
import style0 from "./FpuiPackageEditorTranslation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports